import { TFunction } from 'i18next';
import {
  getRichTextFieldRequiredValidation,
  removeHTMLTags,
} from 'shared/utils';
import * as Yup from 'yup';

export const getReportMessageValidationSchema = (
  t: TFunction,
): Yup.SchemaOf<string> =>
  getRichTextFieldRequiredValidation(
    t('addIncidentReport.inputs.description.required'),
  ).test(
    'is-min-length',
    t('addIncidentReport.inputs.description.minError'),
    (value) => {
      const parsedValue = value ? removeHTMLTags(value).replace(/\s/g, '') : '';
      return parsedValue.length >= 15;
    },
  );
